import Api from '../axios/api';

type CountryCode = 'PL' | 'MD';

/**
 * DAILY_RATE: matrix cell = daily truck rate; cost/t = rate / (t × courses/day),
 *             courses/day = workingHoursPerDay × averageSpeedKmh / (2 × km)
 * PER_TON_KM: matrix cell = price per ton per km; cost/t = km × rate
 */
export type PricingMode = 'DAILY_RATE' | 'PER_TON_KM';

export interface TransportZone {
	from: number;
	to?: number | null;
	pricingMode?: PricingMode;
}

export interface TransportConfigResponse {
	data: TransportConfig;
}

export interface TransportConfig {
	id: string;
	countryCode: CountryCode;
	margin: number;
	workingHoursPerDay: number;
	averageSpeedKmh: number;
	zones: Record<string, TransportZone>;
	categories: Record<string, { from: number; to: number }>;
	priceMatrix: Record<string, { value: Record<string, number> }>;
	updatedAt: string;
}

export type TransportConfigRequest = Omit<TransportConfig, 'id' | 'updatedAt'>;

export interface TransportCostPreview {
	zoneId: string;
	categoryId: string;
	pricingMode: PricingMode;
	distanceKm: number;
	tons: number;
	coursesPerDay?: number;
	costPerTon: number;
	costPerTruck: number;
	pricePerTon: number;
	pricePerTruck: number;
}

export class TransportConfigService {
	static getTransportConfig(
		countryCode: CountryCode = 'PL',
	): Promise<TransportConfigResponse> {
		return Api.get('/v1/admin/transport-config', { params: { countryCode } });
	}

	static updateTransportConfig(
		body: TransportConfigRequest,
	): Promise<TransportConfigResponse> {
		return Api.put('/v1/admin/transport-config', body);
	}

	/** One-truck cost with the SAVED config (same formula as order pricing). */
	static previewTransportCost(params: {
		countryCode: CountryCode;
		distance: number;
		tons: number;
	}): Promise<{ data: TransportCostPreview }> {
		return Api.get('/v1/admin/transport-config/preview', { params });
	}
}
